module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/vfcforearm3-4f2e4fd270fb47e9c8d0027176bfd81d.jpg";